// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__vgM9O","Title":"Header_Title__95QX3","SideButtonContainer":"Header_SideButtonContainer__QluFI"};